import { HTMLAttributes } from 'react'

import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'
import capitalize from 'lodash-es/capitalize'

import { ProjectRole } from '@infura/packages.teams'
import { Select } from '@infura/packages.ui/Select'

const defaultOption = {
  icon: faUsers,
  id: 0,
  text: 'All Roles',
  value: 'all-roles'
}

const rolesOptions = {
  'all-roles': defaultOption,
  ...Object.values(ProjectRole).reduce(
    (f, value, i) => ({ ...f, [value]: { icon: faUsers, id: i + 1, text: capitalize(value), value } }),
    {}
  )
}

export type RolesValue = ProjectRole | 'all-roles'

export interface RolesDropdownProps extends HTMLAttributes<HTMLDivElement> {
  value: RolesValue
  setRole: (role: RolesValue) => void
}

export function RolesDropdown({ setRole, value }: Readonly<RolesDropdownProps>) {
  return (
    <>
      <Select
        className='w-full sm:w-52'
        onChange={({ value }: any) => {
          setRole(value)
        }}
        options={Object.values(rolesOptions)}
        value={rolesOptions[value]}
      />
    </>
  )
}
